function Media() {
  return (
    <section
      id="media"
      className="flex flex-col justify-center bg-yellow-50 p-8 py-24 sm:px-10 md:px-14 lg:px-16"
    >
      <h2 className="w-full text-center font-heading text-4xl text-black md:text-5xl lg:text-6xl">
        Media
      </h2>

      <div className="mx-auto mb-12 max-w-4xl">
        <p className="mt-6 text-center text-lg leading-8 text-gray-600">
          Photos, videos, and press coverage. Content coming soon.
        </p>
      </div>

      {/* Content placeholder - no items to display yet */}
    </section>
  )
}

export default Media
